import script from "./viewAdminUsers.vue?vue&type=script&setup=true&lang=js"
export * from "./viewAdminUsers.vue?vue&type=script&setup=true&lang=js"

import "./viewAdminUsers.vue?vue&type=style&index=0&id=50de308b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-50de308b"]])

export default __exports__